import { SvgIcon, SvgIconProps } from "@mui/material";

export const RightArrow2Icon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M19 12H5M14 17l5-5M14 7l5 5"
      />
    </svg>
  </SvgIcon>
);
